// config.js
// Note: Vite uses import.meta.env instead of process.env
// Environment variables must be prefixed with VITE_ (not REACT_APP_)
//
// Uses a relative base URL (/api) in both dev and prod so the frontend works
// regardless of where it's accessed from (localhost, LAN, Tailscale Serve,
// ngrok, Cloudflare Tunnel, etc.). In dev, Vite's proxy in vite.config.js
// forwards /api + /chat to the Flask backend on localhost:5000.
// Set VITE_API_BASE_URL to override (e.g. for hitting a remote backend).

const config = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
};

export default config;
